var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircleQuestionMarkIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.81,4.16A45.84,45.84,0,1,0,95.65,50,45.84,45.84,0,0,0,49.81,4.16Zm4.71,77.91H45.37V72.63h9.15Zm6.52-32c-3.51,3.52-6.54,6.57-6.54,13.46h-9c0-10.61,5.3-15.93,9.17-19.81,3-3,4.39-4.53,4.39-7.18,0-1.61-.43-9.67-9.06-9.67-7.63,0-9.28,7.39-9.28,9.22h-9c0-7.35,5.81-18.22,18.28-18.22s18.06,9.68,18.06,18.67C68.06,43,64.33,46.75,61,50.05Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleQuestionMarkIcon);
export default __webpack_public_path__ + "static/media/circle-question-mark-icon.0ee39891f01af6da5c5f34e4b35176a7.svg";
export { ForwardRef as ReactComponent };